import {
  validateFormat,
  validatePresence
} from "ember-changeset-validations/validators";
import validateFrenchPhoneNumber from "../validators/french-phone-number";

export default {
  firstName: validatePresence({ presence: true, description: "Le prénom" }),
  lastName: validatePresence({ presence: true, description: "Le nom" }),
  role: validatePresence({ presence: true, description: "Le métier" }),
  email: [validatePresence(true), validateFormat({ type: "email" })],
  phone: validateFrenchPhoneNumber({
    message: "Le numéro de téléphone n'est pas valide"
  }),
  fax: validateFrenchPhoneNumber({
    message: "Le numéro de fax n'est pas valide"
  }),
  secureEmail: validateFormat({
    type: "email",
    description: "L'email sécurisé",
    allowBlank: true
  })
};
